const config = {
    API_URL: "http://localhost:8090",
    QUERY_DEV_TOOLS_ENABLED: false,
    MAX_MESSAGES: 100,
    SOCKET_CONNECTION_INDICATOR_ENABLED: true,
    SOCKET_CONNECTION_URL: "ws://localhost:8090/ws",
    SECRET_KEY: "LocalEncryptionKey",
};

export default config;
